import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'

document.addEventListener('DOMContentLoaded', function(event) {
  ReactDOM.render(<App />, document.getElementById('root'))
})